<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            centered
            no-close-on-backdrop
            @ok="OKClick"
        >
            <div v-if="ModalHTMLMessage != ''" v-html="ModalHTMLMessage"></div>

            <div v-else class="text-center">
                <div>{{ModalMessage}}</div>
            </div>

            <template v-if="can_submit || bag_already_received" #modal-footer>
                <span v-if="can_submit">
                    <b-button variant="secondary" @click="cancelForm">Cancel</b-button>
                    <b-button class="ml-2" variant="primary" @click="submitProductBag">Submit</b-button>
                </span>
                <span v-if="bag_already_received">
                    <b-button variant="secondary" @click="clearFields">Cancel</b-button>
                    <b-button class="ml-2" variant="primary" @click="OKClick">Edit anyway</b-button>
                </span>
            </template>
        </b-modal>
        
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">Product Bag Receiving</h2>
            <p class="tw-italic tw-text-gray-700">
            Process returned product bags
            </p>
        </b-container>
        <br />
        <!-- 1. When the page first loads, allow the user to find the ProductBag -->
        <!-- 2. Once found, figure out how many products are required. -->
        <!-- <b-container fluid v-if="new_product_barcodes.length == 0"> -->
        <b-container fluid v-if="new_product_bag_barcode == '' && used_product_bag_barcode == ''">
            <b-row>
                <b-col cols="3"></b-col>
                <b-col cols="4">
                    <!-- Example Household ID: K-22-384, cluster_number: 22 so barcodes need to start with 88 -->
                    <b-form-input
                        ref="searchInput"
                        v-model="search_term"
                        placeholder="Scan product bag barcode"
                        @keypress.enter="getProductBag"
                    ></b-form-input>
                    <!-- :disabled="household_id != ''" -->
                </b-col>
                <b-col cols="2">
                    <b-button
                        @click="getProductBag"
                        :disabled="household_id != ''"
                    >Search</b-button>
                    <b-button class="ml-2" @click="clearFields()" variant="danger">
                       Clear
                    </b-button>
                </b-col>
                <b-col cols="3"></b-col>
            </b-row>
        </b-container>
        <!-- 3. Scan the bag barcode -->
        <!-- 4. Show a number of barcode inputs equal to the required number found in step 1 -->
        <b-container fluid v-else>
        <b-card bg-variant="light" class="tw-mx-3">
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="10">
                    <h4>Receiving product bag for household ID: {{household_id}}</h4>
                    <h6>Prepared on: {{ prepared_date }}</h6>
                    <h6>New product bag barcode: {{ new_product_bag_barcode }}</h6>
                    <h6>Used product bag barcode: {{ used_product_bag_barcode }}</h6>
                    <h6>Placement Type: {{ placement_type }}</h6>
                    <p>This structure requires {{products_required}} products.</p>
                    <br />
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>
            <!-- If it's not an INITIAL placement -->
            <span v-if="placement_type != 'initial'">
                <b-row>
                    <b-col cols="2"></b-col>
                    <b-col cols="8">
                        <h5>How many used products are in the bag?</h5>
                    </b-col>
                    <b-col cols="2"></b-col>
                </b-row>
                <b-row>
                    <b-col cols="3"></b-col>
                    <b-col cols="6">
                        <b-form-input
                            type="number"
                            pattern="[0-9]*"
                            v-model="returning_product_number"
                        ></b-form-input>
                        <br />
                    </b-col>
                    <b-col cols="3"></b-col>
                </b-row>
                <b-row v-if="returning_product_number > 0">
                    <b-col cols="2"></b-col>
                    <b-col cols="8">
                        <h5>Scan each used product:</h5>
                    </b-col>
                    <b-col cols="2"></b-col>
                </b-row>
                <b-row>
                    <b-col cols="3"></b-col>
                    <b-col cols="6">
                        <span v-for="(field, index) in product_barcode_fields" :key="field.key">
                            <template v-if="isDuplicate(field)">
                                <span class="text-danger">Duplicate barcode entered.<br></span>
                            </template>
                            <template v-if="isNotCorrectLength(field)">
                                <span class="text-danger">The barcode must be 9 characters in length.<br></span>
                            </template>
                            <b-row class="mt-2">
                                <b-col>
                                    <b-form-group
                                        label-cols-sm="3"
                                        :id=field.key
                                        :label=field.text
                                    >
                                        <b-form-input
                                            :id="'usedInput' + (index + 1)"
                                            v-model="field.value"
                                            :placeholder=field.text
                                            @keydown.enter.prevent="advanceInput('used', index + 1)"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </span>
                    </b-col>
                </b-row>
            </span>
            <!-- 5. See if there are any unused products being returned -->
            <span v-if="placement_type != 'final'">
                <b-row>
                    <b-col cols="2"></b-col>
                    <b-col cols="8">
                        <h5>Number of unused products being returned?</h5>
                    </b-col>
                    <b-col cols="2"></b-col>
                </b-row>
                <b-row>
                    <b-col cols="3"></b-col>
                    <b-col cols="6">
                        <b-form-input
                            type="number"
                            pattern="[0-9]*"
                            v-model="unused_product_number"
                        ></b-form-input>
                        <br />
                    </b-col>
                    <b-col cols="3"></b-col>
                </b-row>
                <b-row v-if="unused_product_number > 0">
                    <b-col cols="2"></b-col>
                    <b-col cols="8">
                        <h5>Scan each unused product:</h5>
                    </b-col>
                    <b-col cols="2"></b-col>
                </b-row>
            </span>
            <b-row>
                <b-col cols="3"></b-col>
                <b-col cols="6">
                    <span v-for="(field, index) in unused_barcode_fields" :key="field.key">
                        <template v-if="isDuplicate(field)">
                            <span class="text-danger">Duplicate barcode entered.<br></span>
                        </template>
                        <template v-if="isNotCorrectLength(field)">
                            <span class="text-danger">The barcode must be 9 characters in length.<br></span>
                        </template>
                        <template v-if="isNotPartOfProductList(field)">
                            <span class="text-danger">This barcode was not scanned as a new product during bag preparation.<br></span>
                        </template>
                        <b-row class="mt-2">
                            <b-col>
                                <b-form-group
                                    label-cols-sm="3"
                                    :id=field.key
                                    :label=field.text
                                >
                                    <b-form-input
                                        :id="'unusedInput' + (index + 1)"
                                        v-model="field.value"
                                        :placeholder=field.text
                                        @keydown.enter.prevent="advanceInput('unused', index + 1)"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </span>
                </b-col>
            </b-row>
            <!-- 6. Submit or cancel -->
            <b-row>
                <b-col cols="3"></b-col>
                <b-col cols="6">
                    <b-button
                        class="m-2 col-5"
                        variant="success"
                        @click="checkBarcodes()"
                        :disabled="processing_submit_disabled"
                    >Submit </b-button>
                    <b-button
                        class="m-2 col-5"
                        variant="danger"
                        @click="clearFields()"
                    >Clear</b-button>
                </b-col>
                <b-col cols="3"></b-col>
            </b-row>
        </b-card>
        </b-container>

    </div>
  </template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as _ from "lodash";
  
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
watch: {
    returning_product_number: function(newVal) {
        if (newVal > 100) {
            this.returning_product_number = 100;
        }
        this.product_barcode_fields = [];
        for (let i = 0; i < this.returning_product_number; i++) {
            this.product_barcode_fields.push(
                { key: `product_barcode_${i + 1}`, value: '', text: `Barcode ${i + 1}` }
            );
        }
        // focus on the first barcode field
        setTimeout(() => {
            // There is some weirdness with refs inside v-for loops so I'm just using element ids
            document.getElementById('usedInput1').focus();
        }, 250);
    },
    unused_product_number: function(newVal) {
        if (newVal > 100) {
            this.unused_product_number = 100;
        }
        this.unused_barcode_fields = [];
        for (let i = 0; i < this.unused_product_number; i++) {
            this.unused_barcode_fields.push(
                { key: `product_barcode_${i + 1}`, value: '', text: `Barcode ${i + 1}` }
            );
        }
        // focus on the first barcode field
        setTimeout(() => {
            // There is some weirdness with refs inside v-for loops so I'm just using element ids
            document.getElementById('unusedInput1').focus();
        }, 250);
    }
},
data: function() {
    return {
        showModal: false,
        ModalMessage: '',
        ModalHTMLMessage: '',
        search_term: '',
        new_product_bag_barcode: '',
        used_product_bag_barcode: '',
        household_id: '',
        products_required: 0,
        prev_bag_placed_product_barcodes: [], // These were the barcodes that were in the bag when it was prepared
        new_product_barcodes: [], // These were the barcodes that were in the bag when it was prepared
        used_product_barcodes: [], // These are the barcodes that were scanned when the bag was returned. Return these
        mismatched_product_barcodes: [], // These are barcodes that were scanned but should not be at the household.
        missing_product_barcodes: [], // These are barcodes that should be at the household but were not scanned.
        unused_product_barcodes: [], // These are barcodes that were returned from placement unused.
        missing_product_count: 0,
        prepared_date: '',
        returning_product_number: 0,
        unused_product_number: 0,
        product_barcode_fields: [],  // dynamically populated
        unused_barcode_fields: [],  // dynamically populated
        can_submit: false,
        bag_already_received: false,
        placement_type: '',
    };
},
computed: {
    processing_submit_disabled:function () {
        let disabled = false;
        const that = this;

        // if (that.product_barcode_fields.length == 0) {
        //     disabled = true;
        // }

        // if the placement_type is final, there won't be a new product bag
        if (this.placement_type != 'final') {
            if (this.new_product_bag_barcode == null || this.new_product_bag_barcode == '') {
                disabled = true;
            }
        }

        // Check the used product barcodes
        _.each(this.product_barcode_fields, function(field) {
            if (field.value == null || field.value == '') {
                disabled = true;
            }
        });

        // if there are any duplicate values in the product_barcode_fields, disable the submit button
        _.forEach(that.product_barcode_fields, function(field) {
            if (that.isDuplicate(field)) {
                disabled = true;
            }
        });

        // if there are any values in the product_barcode_fields that are not 9 characters in length, disable the submit button
        _.forEach(that.product_barcode_fields, function(field) {
            if (that.isNotCorrectLength(field)) {
                disabled = true;
            }
        });

        // If there are returning unused products, check their barcodes
        _.each(this.unused_barcode_fields, function(field) {
            if (field.value == null || field.value == '' || that.isNotPartOfProductList(field)) {
                disabled = true;
            }
        });

        // if placement_type is final, there will not be any unused products
        if (this.placement_type != 'final') {
            // if there are any duplicate values in the unused_barcode_fields, disable the submit button
            _.forEach(that.unused_barcode_fields, function(field) {
                if (that.isDuplicate(field)) {
                    disabled = true;
                }
            });

            // if there are any values in the unused_barcode_fields that are not 9 characters in length, disable the submit button
            _.forEach(that.unused_barcode_fields, function(field) {
                if (that.isNotCorrectLength(field)) {
                    disabled = true;
                }
            });
        }

        return disabled;
    }
},
created: function() {},
mounted() {
    this.$refs.searchInput.focus();
},
methods: {
    getProductBag: function () {
        const that = this;
        const fd = new FormData();
        
        fd.append("search_term", that.search_term);
        HTTP.post('srilanka/product_bag/get_product_bag/', fd).then((response) => {
            if(response.data.product_bag_received != null) {
                that.bag_already_received = response.data.product_bag_received;
            }
            if(response.data.message != null) {
                this.ModalMessage = response.data.message;
                this.showModal = true;
            }
            if (response.data.message == null || that.bag_already_received != false) {
                that.prev_bag_placed_product_barcodes = response.data.product_bag.previous_bag_placed_product_ids;
                that.new_product_bag_barcode = response.data.product_bag.new_product_bag_barcode;
                that.used_product_bag_barcode = response.data.product_bag.used_product_bag_barcode;
                that.household_id = response.data.product_bag.household_id;
                that.products_required = response.data.product_bag.products_required;
                that.missing_product_count = response.data.product_bag.missing_product_count;
                that.prepared_date = response.data.product_bag.prepared_date;
                that.new_product_barcodes = response.data.product_bag.new_product_ids;
                that.placement_type = response.data.product_bag.placement_type;
            }
        }).catch((error) => {
            HandleErrors.HandleErrors(error);
            this.ModalMessage = 'There was a problem. Please check barcode and try again.';
            this.showModal = true;
        });
    },
    checkBarcodes: function() {
        const that = this;
        this.ModalHTMLMessage = '';
        that.used_product_barcodes = [];
        that.mismatched_product_barcodes = [];
        that.missing_product_barcodes = [];
        that.unused_product_barcodes = [];
        // for each barcode in the product_barcode_fields, check if it is in the new_product_barcodes
        _.forEach(that.product_barcode_fields, function(field) {
            if (that.prev_bag_placed_product_barcodes.includes(field.value)) {
                // if it is, add it to the used_product_barcodes
                that.used_product_barcodes.push(field.value);
            // if it isn't, it's a mismatch. Add it to the mismatched_product_barcodes
            } else {
                that.mismatched_product_barcodes.push(field.value);
            }
        });
        // for each barcode in the unused_product_barcodes, fields, add it to the unused_product_barcodes list
        _.forEach(that.unused_barcode_fields, function(field) {
            that.unused_product_barcodes.push(field.value);
        });
        // if there are any barcodes in the new_product_barcodes that aren't in the used_product_barcodes or
        // mismatched_product_barcodes, add them to the missing_product_barcodes
        _.forEach(that.prev_bag_placed_product_barcodes, function(barcode) {
            if (!that.used_product_barcodes.includes(barcode) && !that.mismatched_product_barcodes.includes(barcode)) {
                that.missing_product_barcodes.push(barcode);
            }
        });
        this.missing_product_count = this.mismatched_product_barcodes.length;
        this.ModalHTMLMessage = "<h4>Received Product Summary</h4>";
        if(this.used_product_barcodes.length > 0) {
            this.ModalHTMLMessage += "<h5>Used Products Received From This House That Match With The Household ID:</h5>";
            // this.ModalHTMLMessage += "<p><em>These products were in the bag when it was prepared:</em></p>";
            this.ModalHTMLMessage += "<ul>";
            _.forEach(that.used_product_barcodes, function(barcode) {
                that.ModalHTMLMessage += `<li>${barcode}</li>`;
            });
            this.ModalHTMLMessage += "</ul>";
        }
        if(this.mismatched_product_barcodes.length > 0) {
            this.ModalHTMLMessage += "<h5>Used Products Received From This House That Do Not Match With The Household ID:</h5>";
            // this.ModalHTMLMessage += "<p><em>Of the products received, these products were not in the bag when it was prepared:</em></p>";
            this.ModalHTMLMessage += "<ul>";
            _.forEach(that.mismatched_product_barcodes, function(barcode) {
                that.ModalHTMLMessage += `<li>${barcode}</li>`;
            });
            this.ModalHTMLMessage += "</ul>"; 
        }
        if(this.missing_product_barcodes.length > 0) {
            this.ModalHTMLMessage += "<h5>These Products Were In The Previous Household ID’s Placement Bag When It Was Prepared But Were Not Returned:</h5>";
            // this.ModalHTMLMessage += "<p><em>These products were in the previous placement's bag when it was prepared but were not returned:</em></p>";
            this.ModalHTMLMessage += "<ul>";
            _.forEach(that.missing_product_barcodes, function(barcode) {
                that.ModalHTMLMessage += `<li>${barcode}</li>`;
            });
            this.ModalHTMLMessage += "</ul>";
        }
        if(this.unused_product_barcodes.length > 0) {
            this.ModalHTMLMessage += "<h5>These Unused Products Were Returned:</h5>";
            this.ModalHTMLMessage += "<ul>";
            _.forEach(that.unused_product_barcodes, function(barcode) {
                that.ModalHTMLMessage += `<li>${barcode}</li>`;
            });
            this.ModalHTMLMessage += "</ul>";
        }

        this.can_submit = true;
        this.showModal = true;
    },
    submitProductBag: function() {
        const that = this;
        that.ModalHTMLMessage = '';
        const fd = new FormData();
        fd.append("new_product_bag_barcode", that.new_product_bag_barcode);
        fd.append("used_product_bag_barcode", that.used_product_bag_barcode);
        fd.append("cpes_id", that.cpes_id);
        _.each(this.used_product_barcodes, function(barcode) {
            fd.append("used_product_barcodes", barcode);
        });
        _.each(this.mismatched_product_barcodes, function(barcode) {
            fd.append("mismatched_product_barcodes", barcode);
        });
        _.each(this.missing_product_barcodes, function(barcode) {
            fd.append("missing_product_barcodes", barcode);
        });
        _.each(this.unused_product_barcodes, function(barcode) {
            fd.append("unused_product_barcodes", barcode);
        });

        HTTP.post('srilanka/product_bag/submit_received/', fd).then((response) => {
            that.household_id = response.data.household_id;
            _.each(that.form_fields, function(field) {
                field.value = response.data[field.key];
            });
            if(response.data.message != null) {
                that.can_submit = false;
                that.ModalHTMLMessage = '';
                that.ModalMessage = response.data.message;
                that.showModal = true;
            } else {
                that.can_submit = false;
                that.ModalHTMLMessage = '';
                that.ModalMessage = 'Submitted successfully';
                that.showModal = true;
            }
            console.log(response.data.message);
        }).catch((error) => {
            HandleErrors.HandleErrors(error);
            that.ModalMessage = 'There was a problem. Please check input values and try again.';
            that.showModal = true;
        });
        // this.can_submit = false;
        // this.showModal = false;
    },
    OKClick: function() {
        this.showModal = false;
        if (this.bag_already_received != true) {
            this.clearFields();
        }
        this.bag_already_received = false;
    },
    clearFields() {
        this.new_product_bag_barcode = [];
        this.used_product_bag_barcode = [];
        this.search_term = '';
        this.household_id = '';
        this.products_required = 0;
        this.new_product_barcodes = [];
        this.mismatched_product_barcodes = [];
        this.missing_product_barcodes = [];
        this.missing_product_count = 0;
        this.prepared_date = '';
        this.returning_product_number = 0;
        this.unused_product_number = 0;
        this.product_barcode_fields = [];
        this.unused_barcode_fields = [];
        this.can_submit = false;
        this.bag_already_received = false;
        this.showModal = false;
    },
    cancelForm() {
        // this.clearFields();
        this.ModalHTMLMessage = '';
        this.showModal = false;
    },
    isDuplicate(field) {
      return this.product_barcode_fields.some(f => {
        return f.key !== field.key && f.value === field.value && field.value !== '';
      });
    },
    isNotCorrectLength(field) {
      return field.value.length !== 9 && field.value !== '';  
    },
    isNotPartOfProductList(field) {
        return !this.new_product_barcodes.includes(field.value) && field.value !== '';
    },
    advanceInput(type, index) {
        if (index == 999) {
        // I'VE FOUND IT'S TRIVIALLY EASY TO ACCIDENTALLY SUBMIT THE FORM BY SCANNING AGAIN
        // SO I'M COMMENTING THIS OUT FOR NOW
        //     this.$refs.SubmitButton.focus();
            console.log('submittting');
            
        } else {
            let nextInput = index + 1;
            let element = document.getElementById(type + 'Input' + nextInput);
            console.log(element)
            if (element) {
                element.focus();
            } else {
                console.log("no target");
            }
        }
    },
}
};
</script>

<style scoped></style>